<template>
    <a-layout-content class="content">
        <router-view v-slot="{ Component }">
            <transition mode="out-in" name="fade-transform">
                <component :is="Component" />
            </transition>
        </router-view>
    </a-layout-content>
</template>

<script>

</script>
<style scoped lang='less'>
.content{
  height: 100%;
}
.fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>